import React from "react";
import { MDBInput, MDBBtn } from "mdb-react-ui-kit";
import {
  Button,
  Card,
  CardBody,
  Label,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Modal,
  ModalBody,
} from "reactstrap";

import axios from "axios";
import { INSERT_MENUS } from "../../constants";
import NotificationAlert from "react-notification-alert"; 
var filepath = "";
const AddSubmenu = (props) => {
  const notificationAlertRef = React.useRef(null);
  const [parent, setParent] = React.useState({
    name: "",
    displayname: "",
    icon: "",
    submenus: [],
  });
  const [child, setChild] = React.useState([
    {
      name: "",
      displayname: "",
      icon: "",
      imageName:"",
      childmenus: [],
    },
  ]);
  const[dum,setDum] = React.useState();
  const addSubMenu = () => {
    let childObj = [...child];
    let newSubMenu = {
      name: "",
      displayname: "",
      icon: "",
      imageName:"",
      childmenus: [],
    };
    childObj.push(newSubMenu);
    setChild(childObj);
  };

  const changeHandler = (event) => {
    const { name, value } = event.target;
    if (name === "icon") {
      const file = event.target.files[0];
      filepath = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        setParent({ ...parent, [name]: reader.result });
      };

      reader.onerror = (error) => {
        console.log("Error: ", error);
      };
    } else {
      setParent({ ...parent, [name]: value });
    }
  };

  const changeHandlerChild = (event, i) => {
    const { name, value } = event.target;
    let childdata = child.map((item, index) => {
      if (i == index) {
        if (name === "icon") {
          var baseImg = [];
          const file = event.target.files[0];

          const reader = new FileReader();
          reader.readAsDataURL(file);
          setDum(file.name)
         
          setChild({...child,imageName:"jj"})
          reader.onload = () => {
            baseImg.push(reader.result);
          };
         
          let a = { ...item, [name]: baseImg ,imageName:file.name}
          return a;
        } else {
          return { ...item, [name]: value };
        }
      }
      return item;
    });

    setChild(childdata);
  };

  const submitTwoLayer = () => {
    var newmenu = [];

    child.map((item, index) => {
    
      newmenu.push({
        name: item.name,
        filename: item.imageName,
        displayname: item.displayname,
        icon: item.icon[0],
        childmenus: [],
      });
    });

    let body = {
      filename:filepath,
      name: parent.name,
      icon: parent.icon,
      displayname: parent.displayname,
      submenus: newmenu,
    };
    axios
      .post(INSERT_MENUS, body)
      .then((response) => {
        if(response.data.message == "Menu data inserted successfully") {
          let options = {};
          options = {
            place: "tr",
            message: response.data.message,
            type: "success",
            icon: "tim-icons icon-satisfied",
            autoDismiss: 3
          };
          notificationAlertRef.current.notificationAlert(options); 
          setTimeout(() => {
            props.btnSub(false);
          }, 3000);          
          
        }else{
          let options = {};
          options = {
            place: "tr",
            message: response.data.message,
            type: "warning",
            icon: "tim-icons icon-simple-remove",
            autoDismiss: 3
          };
          notificationAlertRef.current.notificationAlert(options);
        }
      })
      .catch((error) => {
        console.log("????", error);
        let options = {};
          options = {
            place: "tr",
            message: "Fill All Input Fields",
            type: "warning",
            icon: "tim-icons icon-simple-remove",
            autoDismiss: 3
          };
          notificationAlertRef.current.notificationAlert(options);
      });

  };

  return (
    <>
      <Col
        className="mb-2"
       
        sm="12"
      >
        <NotificationAlert ref={notificationAlertRef} />
        {/* Parent Menu */}
        <Row>
          <Col md="4" sm="12">
            <Label>Menu Icon</Label>
            <FormGroup>
              <Input
                placeholder="placeholder"
                name="icon"
                type="file"
                style={{
                  opacity: "1",
                  position: "initial",
                  border: "solid 1px #eee",
                }}
                onChange={changeHandler}
              />
            </FormGroup>
          </Col>
          <Col md="4" sm="12" className="mt-4">
            <MDBInput
              label="Menu Title"
              type="text"
              name="name"
              value={parent.name}
              onChange={changeHandler}
            />
          </Col>
          <Col md="4" sm="12" className="mt-4">
            <MDBInput
              label="Display Name "
              type="text"
              name="displayname"
              value={parent.displayname}
              onChange={changeHandler}
            />
          </Col>
        </Row>
        <Row>
          <Col md="10" sm="12">
            <Row>
              {child.map((item, i) => {
                return (
                  <Col sm="12">
                    <Row>
                      <Col md="4" sm="12">
                        <Label>SubMenu Icon</Label>
                        <FormGroup>
                          <Input
                            key={i}
                            placeholder="placeholder"
                            type="file"
                            name="icon"
                            value={child.icon}
                            style={{
                              opacity: "1",
                              position: "initial",
                              border: "solid 1px #eee",
                            }}
                            onChange={(val) => changeHandlerChild(val, i)}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4" sm="12" className="mt-4">
                        <MDBInput
                          key={i}
                          label="SubMenu Tilte"
                          type="text"
                          value={child.name}
                          name="name"
                          onChange={(val) => changeHandlerChild(val, i)}
                        />
                      </Col>
                      <Col md="4" sm="12" className="mt-4">
                        <MDBInput
                          key={i}
                          label="Display Name"
                          type="text"
                          value={child.displayname}
                          name="displayname"
                          onChange={(val) => changeHandlerChild(val, i)}
                        />
                      </Col>
                    </Row>
                  </Col>
                );
              })}
            </Row>
          </Col>
          <Col md="2" sm="12">
            <Button
              className="btn btn-icon btn-add-style  mt-4"
              onClick={addSubMenu}
            >
              <i class="fa fa-plus" aria-hidden="true"></i>
            </Button>
          </Col>
        </Row>
        <Col md="12" sm="12">
          <MDBBtn color="primary" type="button" onClick={submitTwoLayer}>
            Submit
          </MDBBtn>
        </Col>
      </Col>
    </>
  );
};

export default AddSubmenu;
